import axios from "axios";
import { ApiResponseError } from "../errors/api-response-error";
import { REACT_APP_BASE_PERMIT_API_URL, REACT_APP_BASE_PERMIT_API_URL_NEW_API } from "../axios/axios-api";

const CITIZEN_LOGIN = '/login/portal/generate-token';

const useGenerateJwtToken = () => {

    

    async function generateToken(projectId: number, isNewApi: boolean): Promise<string> {

        const baseURL = isNewApi ? REACT_APP_BASE_PERMIT_API_URL_NEW_API : REACT_APP_BASE_PERMIT_API_URL;

        const data = { projectId: projectId };
        let token = '';

        try {

            const response = await axios.post(CITIZEN_LOGIN, data, { baseURL });

            if (!response?.data?.data?.accessToken) {
                throw new ApiResponseError('Generate JWT token API response does not contain accessToken. Response data: ' + JSON.stringify(response.data));
            }

            token = response.data.data.accessToken;
        } catch (error: any) {

            console.error(error);
        }

        return token;
    }

    return {
        generateToken
    };
}

export default useGenerateJwtToken;